// extracted by mini-css-extract-plugin
export default {"form-group":"TenantLogo_form-group__GqzmJ","small":"TenantLogo_small__toepu","medium":"TenantLogo_medium__+Bf5B","large":"TenantLogo_large__JbA7W","logo":"TenantLogo_logo__d3YL-"};